<template>
  <div class="guide-manage">
    <div class="manage-query">
      <el-form
        :inline="true"
        :model="query"
        ref="queryForm"
        :rules="queryRules"
        size="small"
        class="query-middle"
      >
        <el-form-item label="导游姓名：" prop="Name">
          <el-input v-model="query.Name"></el-input>
        </el-form-item>
        <el-form-item label="创建时间：" prop="StartTime" style="margin-left:20px;">
          <el-date-picker
            v-model="query.StartTime"
            type="date"
             format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 200px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="—" prop="EndTime">
          <el-date-picker
            v-model="query.EndTime"
            type="date"
             format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 200px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item  style="margin-left:20px;">
          <el-button type="primary" icon="el-icon-search" @click="loadGuideList"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="info"
            icon="el-icon-circle-close"
            @click="clearQuery('queryForm')"
            >清除</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="manage-content">
      <div class="main-left">
        <div class="main-title">
          <span> <i class="el-icon-folder-opened"></i>导游列表 </span>
          <el-button-group>
            <!-- <el-button icon="el-icon-folder-opened" @click="exportTable" size="mini">导出</el-button> -->
            <el-button
              icon="el-icon-circle-plus-outline"
              type="primary"
              size="mini"
              @click="add"
              >新增</el-button
            >
          </el-button-group>
        </div>
        <div>
          <el-dialog
            title="添加导游"
            :visible.sync="adddialogVisible"
            :close-on-click-modal="false"
            width="50%"
            @closed="resetForm('postForm')"
          >
            <!-- :rules="addformrules" -->
            <el-form
              :model="addForm"
              status-icon
              :rules="addformrules"
              ref="postForm"
              label-width="100px"
              v-if="FlagAdd === 1"
            >
              <el-form-item label="导游证编号" prop="IDNumber">
                <el-input
                  v-model="addForm.IDNumber"
                ></el-input>
              </el-form-item>
              <el-form-item label="姓名" prop="Name">
                <el-input v-model="addForm.Name"></el-input>
              </el-form-item>
              <el-form-item label="性别">
                <el-select v-model="addForm.Sex" placeholder="请选择">
                  <el-option
                    v-for="item in genderMap"
                    :key="item.key"
                    :label="item.val"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="联系电话" prop="Tel">
                <el-input v-model="addForm.Tel"></el-input>
              </el-form-item>
              <el-form-item label="身份证号" prop="IDCard">
                <el-input v-model="addForm.IDCard"></el-input>
              </el-form-item>
              <el-form-item prop="checking" label="验证码">
                  <el-input v-model="addForm.chenking" placeholder="请输入验证码" style="width:82%;"></el-input>
                  <div class="chenk">
                    <template>
                      <span v-show="show" @click="telCheck">
                        <el-button type="primary">获取验证码</el-button>
                      </span>
                      <span v-show="!show" class="count">{{count}} s后重试</span>
                    </template>
                  </div>
              </el-form-item>
              <el-form-item label="照片">
                <el-upload
                  v-if="adddialogVisible"
                  ref="uploadAdd"
                  action="/api/co/Attachment/UploadAttachment"
                  :before-upload="uploadBefore"
                  :on-success="uploadSuccessAdd"
                  :on-remove="uploadRemoveAdd"
                  :on-error="uploadError"
                  list-type="picture"
                  :limit="1"
                  :headers="{
                    AttachmentType: 'scenic-pic',
                    sessionId: voucher.sessionId,
                    'X-Token': voucher.token,
                  }">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip">只能上传图片文件，且不超过10MB，数量为1</div>
                </el-upload>
              </el-form-item>
            </el-form>

            <el-form
              :model="addForm"
              status-icon
              label-width="100px"
              ref="postForm"
              v-if="FlagAdd === 2"
            >
              <el-form-item label="导游证编号" prop="IDNumber">
                <el-input
                  v-model="addForm.IDNumber"
                ></el-input>
              </el-form-item>
              <el-form-item label="姓名" prop="Name">
                <el-input v-model="addForm.Name" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="性别">
                <el-select
                  v-model="addForm.Sex"
                  placeholder="请选择"
                  :disabled="true"
                >
                  <el-option
                    v-for="item in genderMap"
                    :key="item.key"
                    :label="item.val"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="联系电话" prop="Tel">
                <el-input v-model="addForm.Tel" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="身份证号" prop="IDCard">
                <el-input v-model="addForm.IDCard" :disabled="true"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="resetForm('postForm')">取 消</el-button>
              <el-button
                type="primary"
                @click="postModel('postForm')"
                v-if="FlagAdd === 1"
                >确 定</el-button
              >
              <el-button
                type="primary"
                @click="StartBand('postForm')"
                v-if="FlagAdd === 2"
                >绑定导游</el-button
              >
            </span>
          </el-dialog>
        </div>
        <div class="left-table">
          <el-table :data="tableData" height="753px" border style="width: 100%" v-loading="loadingTable">
            <el-table-column
              type="selection"
              min-width="10"
              align="center"
            ></el-table-column>
            <el-table-column
              label="导游证编号"
              prop="IDNumber"
              min-width="120"
              align="center"
            ></el-table-column>
             <el-table-column
              label="姓名"
              prop="Name"
              min-width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              label="所属旅行社"
              prop="CompanyName"
              min-width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              label="绑定时间"
              prop="ApplyTime"
              min-width="140"
              align="center"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.ApplyTime | dateFormat }}</p>
              </template>
            </el-table-column>
            <!-- 导游状态 -->
            <el-table-column
              label="状态"
              prop="GuideStatus"
              min-width="100"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.GuideStatus | keyToVal(statusType1)"
                  effect="dark"
                  size="small"
                  >{{ scope.row.GuideStatus | keyToVal(tripStatus) }}</el-tag
                >
                <el-tag
                  :type="scope.row.Status | keyToVal(guideType)"
                  size="small"
                  >{{ scope.row.Status | keyToVal(guideStatus) }}</el-tag
                >
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              min-width="260"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-button-group>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="lookGuide(scope.row.Id)"
                      >查看</el-button
                    >
                    <el-button
                      size="mini"
                      type="warning"
                      @click="changeGuide(scope.row.Id, 1)"
                      v-if="scope.row.GuideStatus === 0"
                      >禁用</el-button
                    >
                    <el-button
                      size="mini"
                      type="warning"
                      @click="changeGuide(scope.row.Id, 0)"
                      v-if="scope.row.GuideStatus === 1"
                      >启用</el-button
                    >
                    <el-popconfirm
                      title="确认解除绑定吗？"
                      v-on:onConfirm="changeGuide(scope.row.Id, 3)"
                       v-if="scope.row.Status === 1 && scope.row.GuideStatus!=2 "
                    >
                      <el-button size="mini" type="danger" slot="reference" 
                        >解除绑定</el-button
                      >
                    </el-popconfirm>
                  </el-button-group>
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="left-pagination">
          <el-pagination
            class="pagination-bottom"
            background
            layout="prev, pager, next, total,sizes,jumper"
            :total="total"
            :page-size="query.PageSize"
            :page-sizes="[10, 20, 50]"
            :current-page.sync="query.PageIndex"
            v-on:size-change="handleSizeChange"
            v-on:current-change="handleCurrentPageChange"
          ></el-pagination>
        </div>
      </div>
      <div class="main-right">
        <div class="main-title">
          <span> <i class="el-icon-document"></i> 查看 </span>
          <el-button-group>
            <el-button
              type="warning"
              v-show="flag === 1"
              size="mini"
              @click="edit"
              >编辑</el-button
            >
            <el-button
              type="success"
              v-show="flag === 2"
              size="mini"
              @click="save"
              >保存</el-button
            >
          </el-button-group>
        </div>
        <div class="right-table">
          <table class="input-form" v-show="flag === 1" v-loading="loadingLook">
            <thead>
              <tr>
                <th colspan="2">导游信息</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>导游证编号</td>
                <td>{{ detail.IDNumber }}</td>
              </tr>
              <tr>
                <td>姓名</td>
                <td>{{ detail.Name }}</td>
              </tr>
              <tr>
                <td>性别</td>
                <td>{{ detail.Sex }}</td>
              </tr>
              <tr>
                <td>电话</td>
                <td>{{ detail.Tel }}</td>
              </tr>
              <tr>
                <td>身份证号码</td>
                <td>{{ detail.IDCard }}</td>
              </tr>
              <tr>
                <td :rowspan="showPicList.length">导游照片</td>
                <td>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="pictureDialog = true"
                    v-if="showPicList.length > 0"
                    >查看照片</el-button
                  >
                  <span v-else>暂无照片</span>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- 修改 -->
          <table class="input-form" v-show="flag === 2">
            <thead>
              <tr>
                <th colspan="2">导游信息</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>导游证编号</td>
                <td>
                  <el-input
                    v-model="detail.IDNumber"
                    placeholder="请输入导游证编号"
                    :disabled="true"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td>姓名</td>
                <td>
                  <el-input
                    v-model="detail.Name"
                    placeholder="请输入姓名"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td>性别</td>
                <td>
                  <el-select v-model="detail.Sex">
                    <el-option
                      v-for="item in genderMap"
                      :key="item.key"
                      :label="item.val"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </td>
              </tr>
              <tr>
                <td>电话</td>
                <td>
                  <el-input
                    :disabled="true"
                    v-model="detail.Tel"
                    placeholder="请选择电话"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td>身份证号码</td>
                <td>
                  <el-input
                    v-model="detail.IDCard"
                    placeholder="请选择电话"
                  ></el-input>
                </td>
              </tr>
              <tr>
                <td>导游照片</td>
                <td>
                  <el-upload
                    ref="uploadEdit"
                    action="/api/co/Attachment/UploadAttachment"
                    :before-upload="uploadBefore"
                    :on-success="uploadSuccessUpdate"
                    :on-remove="uploadRemove"
                    :on-error="uploadError"
                    :file-list="showPicList"
                    list-type="picture"
                    :limit="1"
                    :headers="{
                      AttachmentType: 'scenic-pic',
                      BelongIndex: detail.Id,
                      sessionId: voucher.sessionId,
                      'X-Token': voucher.token,
                    }"
                  >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip">只能上传图片文件，且不超过10MB,数量为1</div>
                  </el-upload>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <el-dialog
          title="导游照片"
          :visible.sync="pictureDialog"
          width="50%"
          center
          class="picture-dialog"
        >
          <el-carousel indicator-position="outside" :loop="false">
            <el-carousel-item v-for="picId in showPicList" :key="picId.Id">
              <el-image
                :src="complementPicUrl(picId.Id)"
                fit="scale-down"
                style="height: 100%"
              >
                <div slot="placeholder">加载中....</div>
              </el-image>
            </el-carousel-item>
          </el-carousel>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { keyToVal, dateFormat } from "../filters/filters";
import GUIDE from "@/api/guide";
import { mapState } from "vuex";
import Attachment from "@/api/common";
import REGISTER from "../api/member";
export default {
  name: "GuideManage",
  inject: ["voucher", "complementPicUrl"],
  data() {
    return {
      loadingTable:false,
      loadingLook:false,
      FlagAdd: 1, //1:先添加、再绑定 2:直接绑定操作

      query: {
        Name: "",
        StartTime: "",
        EndTime: "",
        PageSize: 10,
        PageIndex: 1,
      },
      showPicList: [],
      pictureDialog: false,
      total: 0,
      adddialogVisible: false,

      detail: {
        Name: "",
        Sex: "",
        Tel: "",
        IDNumber: "",
        picUrl: "",
      },
      form: {
        Name: "",
        Sex: "",
        Tel: "",
        IDNumber: "",
        picUrl: "",
      },
      flag: 0,
      addForm: {
        IDNumber: "",
        Name: "",
        Sex: "",
        Tel: "",
        IDCard: "",
        Images: [],

        chenking:"",//验证码
      },
      count: "",
      show: true,
      

      addformrules: {
        IDNumber: [
          { required: true, message: "请输入导游证编号", trigger: "blur" },
        ],
        Name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        Tel: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
        IDCard: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
        ]
      },
      queryRules: {},
      fileList: [
        //ele-ui upload已有图片列表
        {
          name: "food.jpeg",
          url: "",
        },
      ],
      tableData: [],
    };
  },
  filters: {
    keyToVal,
    dateFormat,
  },
  computed: {
    ...mapState("common", ["genderMap"]),
    ...mapState("common", [
      "tripStatus",
      "statusType1",
      "tripShowStatus",
      "guideStatus",
      "guideType",
    ]),
  },
  methods: {
    //失去焦点,获取导游信息
    SelectIDNumber(IDNumber) {
      var param = { IDNumber: IDNumber };
      GUIDE.selectIDNumber(param).then((res) => {
        if (res.status == "success") {
          if (res.content != null && res.content != "") {
            this.FlagAdd = 2; //直接绑定
            this.addForm.Name = res.content.Name;
            this.addForm.Sex = res.content.Sex;
            this.addForm.Tel = res.content.Tel;
            this.addForm.IDCard = res.content.IDCard;
            //清除文本框的校验规则
            this.$refs["postForm"].clearValidate(["Name"]);
            this.$refs["postForm"].clearValidate(["Tel"]);
            this.$refs["postForm"].clearValidate(["IDCard"]);
          } else {
            this.FlagAdd = 1; //先添加
            this.addForm.Name = "";
            this.addForm.Sex = "";
            this.addForm.Tel = "";
            this.addForm.IDCard = "";
          }
        }
      });
    },
    //绑定导游
    StartBand(formName) {
      GUIDE.guideBand(this.addForm).then((res) => {
        if (res.status == "success") {
          this.$message.success(res.msg);
          this.adddialogVisible = false;
          this.loadGuideList();

          this.$refs[formName].clearValidate();
          this.$refs[formName].resetFields();
        } else {
          this.$message.error(res.msg);
        }
      });
     
    },

    //关闭弹窗后清空表单
    resetForm(formName) {
      this.$refs[formName].clearValidate();
      this.$refs[formName].resetFields();

      this.adddialogVisible=false;
      this.showPicList = [];
    },
    //清除查询条件，重新获取
    clearQuery(formName) {
      if (formName === "queryForm") {
        this.query = {
          Name: "",
          StartTime: "",
          EndTime: "",
          PageSize: 10,
          PageIndex: 1,
        };
        //this.getData();
      } else if (formName === "postForm") {
        this.form = {
          Name: "",
          Sex: "",
          Tel: "",
          IDNumber: "",
          picUrl: "",
        };
      }
      this.loadGuideList();
    },
    //查询
    loadGuideList() {
      this.loadingTable=true;
      GUIDE.loadGuideList(this.query).then((res) => {
        this.total = res.content.Total;
        this.tableData = res.content.OnePageData;
        this.loadingTable=false;
      });
    }, 
    //通过id查询
    lookGuide(Id) {
      var _self=this;
      const param = {
        Id,
      };
      _self.loadingLook=true;
      GUIDE.lookGuide(param).then((res) => {
        if (res.status === "success") {
          _self.detail = res.content.data;

          _self.showPicList = res.content.GuideImages.map((v) => {
            let data = {
              Id: v.Id,
              name: v.FileName,
              url: _self.complementPicUrl(v.Id),
            };
            return data;
          });
          _self.flag = 1;
        } else {
          _self.$message.error("获取失败!");
        }
        _self.loadingLook=false;
      });
    },
    //添加
    postModel(formName) {
      var _self=this;
      _self.$refs[formName].validate((success) => {
        if (success) {
          if(_self.addForm.chenking=="" || _self.addForm.chenking==null){
            _self.$message.error("请获取验证码!");
            return false;
          }
       
          GUIDE.addGuide(_self.addForm).then((res) => {
            if (res.status === "success") {
              _self.adddialogVisible = false;
              _self.$message.success("添加成功!");
              _self.loadGuideList();
            } else {
              _self.$message.error(res.msg);
            }
          });
        } else {
          _self.$message.error("请补全信息!");
        }
      });
    },
    
    //获取验证码
    telCheck(){
      var _self=this;
       if (!_self.addForm.Tel) {
        _self.$message.error("未获取到联系方式!");
        return;
      }
      REGISTER.getCode({ tel: _self.addForm.Tel }).then((res) => {
        if (res.status === "success") {
          _self.$message.success("获取成功!");
            const TIME_COUNT = 60;
            if (!_self.timer) {
              _self.count = TIME_COUNT;
              _self.show = false;
              _self.timer = setInterval(() => {
                if (_self.count > 0 && _self.count <= TIME_COUNT) {
                  _self.count--;
                } else {
                  _self.show = true;
                  clearInterval(_self.timer);
                  _self.timer = null;
                }
              }, 1000);
            }
        } else {
          _self.$message.error(res.message);
        }
      });
    },
    
    //禁用 删除 解除绑定
    changeGuide(Id, status) {
      switch (status) {
        case 0:
          GUIDE.enableGuid({ Id }).then((res) => {
            if (res.status === "success") {
              this.$message.success("修改成功!");
              this.loadGuideList();
            } else {
              this.$message.error(res.msg);
            }
          });
          break;
        case 1:
          GUIDE.disableGuid({ Id }).then((res) => {
            if (res.status === "success") {
              this.$message.success("禁用成功!");
              this.loadGuideList();
            } else {
              this.$message.error(res.msg);
            }
          });
          break;
        case 3://解除绑定
          GUIDE.relieveGuid({ Id }).then((res) => {
            if (res.status === "success") {
              this.$message.success(res.msg);
              this.loadGuideList();
            } else {
             this.$message.error(res.msg);
            }
          });
          break;
        default:
          break;
      }
      
    },
    //修改保存
    save() {
      var _self=this;
      if(_self.detail.Sex=="男" || _self.detail.Sex=="女"){
        _self.detail.Sex=_self.detail.Sex=="男"?1:0;
      }
      _self.detail.Images = _self.showPicList.map((v) => v.Id);
      GUIDE.updateGuide(_self.detail).then((res) => {
        if (res.status === "success") {
          _self.$message.success("修改成功!");
          _self.flag = 0; //修改成功，重新获取数据，修改flag
          _self.loadGuideList();
        } else {
          _self.$message.error(res.msg);
        }
      });
      _self.loadGuideList();
    },

    getDetail() {
      this.flag = 1;
    },
    edit() {
      this.flag = 2;
    },
    changeState() {
      //row,type
    },

    add() {
      this.adddialogVisible = true;
      this.addForm = {
        IDNumber: "",
        Name: "",
        Sex: "",
        Tel: "",
        IDCard: "",
        Images: [],
      };
      this.FlagAdd = 1;
    },

    handleSizeChange(val) {
      this.query.PageSize = val;
    },
    //分页  页码改变
    handleCurrentPageChange(val) {
      this.query.PageIndex = val;
    },
    //图片上传之前判断
    uploadBefore(file) {
      let fileType = file.type,
        isImage = fileType.indexOf("image") != -1,
        isBig = file.size <= 1024 * 1024 * 10;
      if (!file) {
        this.$refs.upload.onError();
        this.$message.error("上传为空！");
        return false;
      }
      if (!isImage) {
        this.$refs.upload.onError();
        this.$message.error("只能上传图片！");
        return false;
      }
      if (!isBig) {
        this.$refs.upload.onError();
        this.$message.error("图片大小不能超过10MB！");
        return false;
      }
      return true;
    },
    //图片上传成功之后回传
    uploadSuccessAdd(res) {
      if (res.status === "success") {
        this.$message.success("图片上传成功！");
        this.addForm.Images.push(res.content);
      } else {
        this.$message.error("上传失败！");
      }
    },

    uploadSuccessUpdate(res) {
      if (res.status === "success") {
        this.$message.success("图片上传成功！");
        this.showPicList.push({
          Id: res.content,
          url: this.complementPicUrl(res.content),
        });
      } else {
        this.$message.error("上传失败！");
      }
    },

    //图片上传失败
    uploadError() {
      this.$message.error("上传失败！");
    },
    //图片移除上传
    uploadRemoveAdd(file) {
      Attachment.deleteAttachment({
        AttachmentStatus: -1,
        AttachmentId: file.response.content,
      }).then((res) => {
        if (res.status === "success") {
          const index = this.addForm.Images.indexOf(file.response.content);
          if (index !== -1) {
            this.addForm.Images = this.addForm.Images.slice(index, 1);
          }
          this.$message.success("删除成功");
        } else {
          this.$message.error("删除失败");
        }
      });
    },
    uploadRemove(file) {
      Attachment.deleteAttachment({
        AttachmentStatus: -1,
        AttachmentId: file.Id,
      }).then((res) => {
        if (res.status === "success") {
          this.showPicList.pop();
          this.$message.success("删除成功");
        } else {
          this.$message.error("删除失败");
        }
      });
    },
  },
  created() {
    this.loadGuideList();
  },
  watch: {
    "query.PageSize": function () {
      this.loadGuideList();
    },
    "query.PageIndex": function () {
      this.loadGuideList();
    },
    //监听导游证编号文本框
    "addForm.IDNumber":function(val){
      this.SelectIDNumber(val);
    },
  },
};
</script>

<style scoped lang="less">
.chenk {
  // position: relative;
  // top: -40px;
  // left: 701px;
  display: inline-block;
  width: 110px;
  height: 40px;
  border-radius: 10px;
  text-align: center;
  background-color: rgb(211, 209, 209);
}
.main-left {
  width: 40%;
  border-right: 1px solid #ddd;
}
.main-left .left-table {
  height: 753px;
}
.main-left .left-pagination {
  height: 40px;

  background: #dedede;
  text-align: center;
}
.left-pagination .pagination-bottom {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.main-right {
  flex: 1;
  min-width: 600px;
}
.right-table {
  padding: 20px;
  min-width: 700px;
}
.input-form {
  width: 50%;
  border-collapse: collapse;
  border: 1px solid #aaa;
  thead {
    width: 100%;
    background-color: #f1f1f1;
    border: 1px solid #aaa;
  }
  th,
  tr {
    height: 33px;
    border: 1px solid #aaa;
  }
  td,
  th {
    text-align: center;
    vertical-align: middle;
    border: 1px solid #aaa;
  }
}
.input-form /deep/ .el-select {
  width: 100%;
}
.input-form /deep/ .el-input__inner {
  border: none;
  width: 100%;
}
.guide-manage /deep/.el-carousel__container {
  text-align: center;
}
</style>
